import { toRaw } from 'vue';

export function toggleStringInArray<G>(inputArr: Array<G>, value: G): Array<G> {
  const arr = [...inputArr];
  if (arr.includes(value)) return arr.filter((i) => i !== value);
  arr.push(value);
  return [...arr];
}

export function deepEqual(a: any, b: any, ignoreKeys: string[] = []): boolean {
  if (a === b) return true;
  if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object')
    return false;

  if (Array.isArray(a) !== Array.isArray(b)) return false;

  const keysA = Object.keys(a).filter((k) => !ignoreKeys.includes(k));
  const keysB = Object.keys(b).filter((k) => !ignoreKeys.includes(k));
  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!keysB.includes(key)) return false;
    if (!deepEqual(a[key], b[key], ignoreKeys)) return false;
  }

  return true;
}

export function rawDeep(obj: any): any {
  if (obj && typeof obj === 'object') {
    obj = toRaw(obj);
    if (Array.isArray(obj)) return obj.map(rawDeep);
    const res: any = {};
    for (const key in obj) res[key] = rawDeep(obj[key]);
    return res;
  }
  return obj;
}

export function compare2Array<T>(
  firstArray: T[],
  secondArray: T[]
): T | undefined {
  const firstSet = new Set(firstArray);
  const secondSet = new Set(secondArray);
  for (const i of firstSet) {
    if (!secondSet.has(i)) return i;
  }
  return;
}

export function fixMojibake(str: string): string {
  const bytes = new Uint8Array(str.split('').map((c) => c.charCodeAt(0)));
  return new TextDecoder('utf-8').decode(bytes);
}
